import { render } from "./CourseSectionRow.vue?vue&type=template&id=87050bee&scoped=true"
import script from "./CourseSectionRow.vue?vue&type=script&lang=js"
export * from "./CourseSectionRow.vue?vue&type=script&lang=js"

import "./CourseSectionRow.vue?vue&type=style&index=0&id=87050bee&lang=sass&scoped=true"

import exportComponent from "../../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87050bee"]])

export default __exports__